// extracted by mini-css-extract-plugin
export default {"imagecontainer":"SmallBackgroundImage_imagecontainer__zBdv9","content":"SmallBackgroundImage_content__2Uch8"};